<script setup="">
import { computed } from "vue";

import SimpleSelect from "@/Components/Form/SimpleSelect.vue";

const props = defineProps({
  campaign: {
    type: Object,
    required: true
  },
  update: {
    type: Function,
    required: true
  }
});

const indexPage = computed({
  get() {
    return props.campaign.settings?.index ?? "home";
  },
  set(value) {
    props.update("settings.index", value);
  }
});
</script>

<template>
  <div>
    <SimpleSelect v-model="indexPage">
      <option value="home">홈</option>
      <option value="page">페이지</option>
    </SimpleSelect>
  </div>
</template>
